module.exports = __webpack_public_path__ + "img/spain.bd6d1bba.svg";